import { useQuery } from "@tanstack/react-query"
import { useParams, useSearchParams } from "react-router-dom"

import { API_IDENTIFICATION_URL } from "../constants"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

interface IdentifyResponse {
  createdOn: string
  identificationLevel: string
  identificationNumber: number
  identificationRequestId: string
  status: "Accepted" | "Rejected" | null
  updatedOn: string
}

const identification = async (
  token: string | null,
  id: string | undefined,
): Promise<IdentifyResponse> => {
  const response = await axios(`${API_IDENTIFICATION_URL}/${id}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })

  if (checkIsFailure(response.status)) {
    throw new Error(
      `Ошибка при запросе данных: ${response.status} - ${response.statusText}`,
    )
  }

  return response.data
}

export const useIdentification = () => {
  const location = useParams()
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token")

  return useQuery<IdentifyResponse>({
    queryKey: ["payment-identification", location.id],
    queryFn: () => identification(token, location.id),
    enabled: Boolean(token) && Boolean(location.id),
    refetchInterval: (data) => {
      if (
        data?.state?.data?.status === "Accepted" ||
        data?.state?.data?.status === "Rejected"
      ) {
        // Прекращаем опрос, когда получен финальный статус
        return false
      }
      // Продолжаем опрос каждую секунду
      return 1000
    },
  })
}
